import { BREAKPOINTS } from '../config';
import { lockScroll, unlockScroll } from '../utils/lockscroll';

const mq = window.matchMedia(`(max-width: ${BREAKPOINTS.mqTouch}px)`);

const html = document.documentElement;
const header = document.querySelector('.header');
const burger = document.querySelector('.burger');
const mobMenu = document.querySelector('.mobmenu');
const mobMenuBody = document.querySelector('.mobmenu__body');

const links = document.querySelectorAll('.menu-item-has-children > a');
links.forEach(link => {
  if (link.getAttribute('href') === '#') {
    link.addEventListener('click', event => event.preventDefault());
  }
});

let isMenuOpened = false;

function setMenuState(open) {
  isMenuOpened = open;

  html.toggleAttribute('data-open-mobmenu', open);

  if (open) {
    lockScroll(mobMenuBody);
  } else {
    unlockScroll();
  }
}

function handleMenuClick(e) {
  const link = e.target.closest('a');
  if (!link) return;

  if (isMenuOpened) {
    setMenuState(false);
  }
}

function toggleMenu() {
  setMenuState(!isMenuOpened);
}

function handleBreakpoint(e) {
  if (!e.matches && isMenuOpened) {
    setMenuState(false);
  }
}

function initMenu() {
  if (!burger || !mobMenu) return;

  burger.addEventListener('click', toggleMenu);
  mobMenu.addEventListener('click', handleMenuClick);

  mq.addEventListener('change', handleBreakpoint);
}

let rafId = null;

function setViewportVars() {
  if (rafId) return;

  rafId = requestAnimationFrame(() => {
    rafId = null;

    // vh
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // header height
    if (header) {
      const hh = header.offsetHeight;
      document.documentElement.style.setProperty('--hh', `${hh}px`);
    }
  });
}

window.addEventListener('resize', setViewportVars);
window.addEventListener('orientationchange', setViewportVars);
document.addEventListener('DOMContentLoaded', () => {
  setViewportVars();
  initMenu();
});
